document.addEventListener("DOMContentLoaded", () => {
	openMobileMenu();
	showSubMenu();
});

// mobile menu
function openMobileMenu() {
	const openBtn = document.querySelector('.open-menu');

	if (openBtn) {
		openBtn.addEventListener('click', function(event) {
			event.preventDefault();
			if ( document.body.classList.contains('menu-opened') ) {
				document.body.classList.remove('menu-opened');
				[...document.querySelectorAll('.sub-menu')].forEach(item => item.classList.remove('show'));
			} else {
				document.body.classList.add('menu-opened');
			}
		});
	}
};

function showSubMenu() {
	const parentBtns = document.querySelectorAll('.header li.menu-item-has-children > a');
	const closeSubMenu = document.createElement('li');
	closeSubMenu.classList.add('sub-menu__close');
	closeSubMenu.innerHTML = '<span>< Back</span>';

	if(parentBtns) {
		[...parentBtns].forEach(item => {
			item.parentNode.querySelector('.sub-menu').prepend(closeSubMenu.cloneNode(true));
			item.addEventListener('click', function(e) {
				e.preventDefault();
				this.parentNode.querySelector('.sub-menu').classList.add('show');
				return false;
			});
		});

		const backSubMenuBtns = document.querySelectorAll('.sub-menu__close');
		if(backSubMenuBtns) {
			[...backSubMenuBtns].forEach(item => {
				item.addEventListener('click', function(e) {
					e.preventDefault();
					this.parentNode.classList.remove('show');
					return false;
				});
			});
		}
	}
}